<template lang="pug">
v-layout(column)

  v-card.mr-4.elevation-0
    v-data-table(
      :headers='headers',
      :items='filteredLeases',
      :expand='true',
      item-key='id',
      :pagination.sync='pagination',
      :search='$store.state.filters.search',
      :loading='loading',
      :must-sort='true',
      :rows-per-page-items='[10, 50]'
      )

      template(slot='items', slot-scope='props')
        tr
          td(style='width: 20px;padding: 0 0 0 20px')
            v-tooltip(right)
              v-icon(color='orange', v-if='props.item.testLease', slot='activator') fas fa-exclamation-triangle
              | Test lease

          td {{ props.item.number }}

          td {{ props.item.createdAt | date }}

          td {{ props.item.domain }}

          td.text-xs-right
            LeaseOptions(@deleted='deletedLease', :lease='props.item')

</template>

<script>
import Moment from 'moment'

export default {
  name: 'PrivateLeases',

  components: {
    LeaseOptions: require('@/components/Table/LeaseOptions').default
  },

  data () {
    return {
      search: null,
      headers: [
        {
          text: null,
          sortable: true,
          value: 'testLease'
        },
        {
          text: 'ID',
          sortable: false,
          value: 'number'
        },
        {
          text: 'Datum',
          sortable: true,
          value: 'createdAt'
        },
        {
          text: 'Websiteprofiel',
          sortable: true,
          value: 'domain'
        },
        {
          text: '',
          sortable: false
        }
      ],

      pagination: {
        sortBy: 'createdAt',
        descending: true
      },

      leases: [],
      loading: true
    }
  },

  computed: {
    filteredLeases () {
      const domain = this.$store.state.filters.domain
      const monthOffset = this.$store.state.filters.monthOffset

      const selectedMonth = Moment().add(monthOffset, 'month')

      return this.leases.filter(x =>
        (!domain || x.domain === domain) &&
        (monthOffset === null || Moment(x.createdAt).isSame(selectedMonth, 'month'))
      )
    }
  },

  methods: {
    deletedLease (leaseId) {
      this.leases.splice(this.leases.findIndex(x => x.id === leaseId), 1)
    },

    async load () {
      this.loading = true

      this.leases = await this.$store.dispatch('graphqlQuery', {
        name: 'getAllPrivateLeases',
        variables: {
          orgId: this.$store.state.organization.currentOrgId
        },
        ignoreCache: true
      })

      this.loading = false
    }
  },

  async created () {
    await this.load()
  }
}
</script>

<style lang="scss" scoped>
</style>
